const createHistory = require('history').createBrowserHistory

export default new createHistory()
